import React from 'react';
import { HomefieldIconArrowTrendUp } from '@dsg-tech/homefield-react-icons';
import { dataEmPrepText } from 'utility/common-utils';
import { TrendingSearchCta } from 'types';

interface ConsolidatedNavTrendingSearchProps {
  trendingSearches: TrendingSearchCta[];
}

const ConsolidatedNavTrendingSearch: React.FC<ConsolidatedNavTrendingSearchProps> = ({
  trendingSearches,
}) => {
  return (
    <>
      {trendingSearches.map((item, index) => {
        const classes = [
          'hmf-px-xxs hmf-mx-xxxs hmf-display-flex hmf-align-items-center',
          ...(index === trendingSearches.length - 1 ? ['hmf-pr-l'] : []),
        ].join(' ');
        return (
          <div key={`consolidated-${item.linkTitle}`} className={classes}>
            <a
              className="consolidated-header-link-title hmf-display-flex hmf-align-items-center hmf-header-xs hmf-mr-xxxs"
              href={item.link}
              aria-label={`Navigate to ${item.linkTitle} page`}
              data-em={`Header_FeaturedNav_${dataEmPrepText(item.linkTitle)}`}>
              {item.linkTitle}
            </a>
            <div className="consolidated-header-arrow-icon hmf-display-flex hmf-flex-wrap hmf-align-content-center hmf-justify-content-flex-end left-gradient">
              <HomefieldIconArrowTrendUp width={16} height={16} data-testid="arrowTrendUp" />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ConsolidatedNavTrendingSearch;
